export const DEFAULT_NAVIGATION_SENSITIVITY = 10;

/**
 * Number of days of journal entries to sync
 */
export const JOURNAL_ENTRIES_NUM_DAYS = 14;

/**
 * Time in minutes to check for a new version of the website
 */
export const CHECK_FOR_UPDATE_MINUTES = 15;

/**
 * Google API key
 */
export const GOOGLE_API_KEY = "AIzaSyCThimz5fkEVi7lyp3lbq-gSkAU3_QQizw";

/**
 * Time to wait trying a datastore operation before showing the saving message
 */
export const DATASTORE_SAVE_WAIT_TIME = 500;
